import { UserRoleEnum } from "../types";
import { EventsType } from "react-idle-timer";

export const IntercomCheckListID = "28392342";
export const ExitTicketExpirationTime = 60 * 24; // 24 hr
export const ResearchExpirationTime = 60 * 72; // 72 hr
export const isDev = import.meta.env.DEV;
export const countries: { [key: string]: any } = {
  AU: "Australia",
  CA: "Canada",
  US: "USA",
};

export const rolesOptions = [
  { value: UserRoleEnum.User, label: "Teacher" },
  { value: UserRoleEnum.Admin, label: UserRoleEnum.Admin },
  { value: UserRoleEnum.DistrictAdmin, label: UserRoleEnum.DistrictAdmin },
  { value: UserRoleEnum.SuperAdmin, label: UserRoleEnum.SuperAdmin },
];

export const districtAdminRoles = [
  { value: UserRoleEnum.DistrictAdmin, label: "OP District Administrator" },
  { value: UserRoleEnum.Admin, label: "OP School Administrator" },
  { value: UserRoleEnum.User, label: "Educator" },
];

export const countryOptions = [
  { value: "US", label: "USA" },
  { value: "AU", label: "Australia" },
  { value: "CA", label: "Canada" },
];
export const contentOptions = [
  { value: "Units", label: "Units" },
  { value: "Lessons", label: "Lessons" },
  { value: "OP Reels", label: "OP Reels" },
];
export const unitOptions = [
  { value: "Lessons", label: "Lessons" },
  { value: "Collections", label: "Collections" },
];
export const gradeLabelPositionOptions = [
  { label: "Top Left", value: "tl" },
  { label: "Top Right", value: "tr" },
  { label: "Bottom Left", value: "bl" },
  { label: "Bottom Right", value: "br" },
];

export const collectionTypeOptions = [
  {
    label: "Display Individual Lesson Images",
    value: "Individual_Lesson_Image",
  },
  { label: "Display Collection Image", value: "Collection_Image" },
  { label: "Display Theme", value: "Theme" },
];

export const ParentLoginPageVideoLink =
  "https://stream.mux.com/RS6fs02xO66i3yDolNAt4pfDv2IKspgUfA1HuHuNwvcQ.m3u8";
// export const ParentLoginPageVideoLink = 'https://stream.mux.com/YlDKgzFkKRNwP29AkQFLy537uJuLsaiB695wlhQH6WE.m3u8';

export const apiUrl = import.meta.env.VITE_DATA_URL || "";
export const isAlphaOrProd =
  apiUrl.includes("alpha.openparachuteapp.com") ||
  apiUrl.includes("learn.openparachuteschools.com");
export const isStage = apiUrl.includes("stage.openparachute.dev");
export const WellBeingUnitId = isAlphaOrProd
  ? "z61fAiDzCP7YPf4ph5_VD"
  : "z61fAiDzCP7YPf4ph5_VD";
export const EducatorOnboardingId = "7st7t9-n26J89cOK8d0QG";
export const GroupOnboardingId = "4rNe4ip3FbpiecWcCL4Mr";
export const CreatingResilientClassroomsId = "U9bhLVVv0CMnCGR7Q3ICk";
export const CreatingResilientAusClassroomsId = "U-SbNIWWKH0G6G2Evw-7t";
export const AusEducatorOnboardingId = isAlphaOrProd
  ? "xOC8xSok1boIzBL79joHQ"
  : "V3YDdsODg4w77CTJ2hpaZ";
export const StudentWellBeingSurveyId = "ikAq5N7Vlb0GkAYt_GvNo";
export const PlatformTowerId = "SDRasnuxojYIQqT56XpSw";
export const BookStudyUnitName =
  "finding-the-words-book-study-helping-students-thrive";

export const IsPasswordProtected = !isAlphaOrProd && !isDev;
export const PasswordSaveKey = "DevPassword";
export const MUX_KEY = "rmpmn9486dogs6am90r0ie26r";
// nv7vf3770krre6ncgb8vcuaah -- dev

export const GROUP_ID_BY_COUNTRY = {
  US: "3",
  AU: "2",
  CA: "1",
};

export const isHomeEDApp = import.meta.env.VITE_HOME_ED_APP === "true";
export const isUrlShortenApp = import.meta.env.VITE_URL_SHORTEN_APP === "true";
export const parentPlanName = "Parent & Caregiver";

export const SURVEY_TYPE = {
  EXIT_TICKET: 1,
  RESEARCH: 2,
  NA_PRE_PROGRAM_QUIZ: 3, // North America Pre-Program Survey
  AU_POST_PROGRAM_QUIZ: 4, // Australian Post-Program Survey
  AU_PRE_PROGRAM_QUIZ: 5, // Australian Pre-Program Survey
  NA_POST_PROGRAM_QUIZ: 6, // North America Post-Program Survey
  ABSENT_STUDENT: 7, // Absent Student Survey
};

export const ageOptions = [
  { label: "5-7", value: "5-7" },
  { label: "8-10", value: "8-10" },
  { label: "11-13", value: "11-13" },
  { label: "14-18", value: "14-18" },
  {
    label: "Parent & Caregiver - Getting Started",
    value: "Parent & Caregiver - Getting Started",
  },
  {
    label: "Parent & Caregiver - Resources",
    value: "Parent & Caregiver - Resources",
  },
];

export const standaloneLessonsAgeOptions = [
  { label: "Pre-K & K", value: "Pre-K & K" },
  { label: "Grade 1 & 2", value: "Grade 1 & 2" },
  { label: "Grade 3 & 4", value: "Grade 3 & 4" },
  { label: "Grade 5 & 6", value: "Grade 5 & 6" },
  { label: "Grade 7 & 8", value: "Grade 7 & 8" },
  { label: "Grade 9 - 12", value: "Grade 9 - 12" },
];

export const EDUCATOR_CONTENT_AGE_GROUP_VALUE = "Educator Content";

export const AustraliaStandaloneLessonAgeGroupOptions = [
  { label: "Kindy/Reception", value: "Kindy/Reception" },
  { label: "Year 1", value: "Year 1" },
  { label: "Year 2", value: "Year 2" },
  { label: "Year 3", value: "Year 3" },
  { label: "Year 4", value: "Year 4" },
  { label: "Year 5", value: "Year 5" },
  { label: "Year 6", value: "Year 6" },
  { label: "Year 7", value: "Year 7" },
  { label: "Year 8", value: "Year 8" },
  { label: "Year 9", value: "Year 9" },
  { label: "Year 10", value: "Year 10" },
  { label: "Year 11", value: "Year 11" },
  { label: "Year 12", value: "Year 12" },
  {
    label: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
    value: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
  },
];

export const NorthAmericaStandaloneLessonAgeGroupOptions = [
  { label: "Pre-K", value: "Pre-K" },
  { label: "Kindergarten", value: "Kindergarten" },
  { label: "Grade 1", value: "Grade 1" },
  { label: "Grade 2", value: "Grade 2" },
  { label: "Grade 3", value: "Grade 3" },
  { label: "Grade 4", value: "Grade 4" },
  { label: "Grade 5", value: "Grade 5" },
  { label: "Grade 6", value: "Grade 6" },
  { label: "Grade 7", value: "Grade 7" },
  { label: "Grade 8", value: "Grade 8" },
  { label: "Grade 9", value: "Grade 9" },
  { label: "Grade 10", value: "Grade 10" },
  { label: "Grade 11", value: "Grade 11" },
  { label: "Grade 12", value: "Grade 12" },
  { label: "Grade K-12", value: "Grade K-12" },
  {
    label: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
    value: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
  },
];

export const GRADE_K_12_VALUE = "Grade K-12";

export const GRADE_K_12_EXPANDED_GRADES =
  NorthAmericaStandaloneLessonAgeGroupOptions.filter(
    (option) =>
      option.value !== GRADE_K_12_VALUE &&
      option.value !== EDUCATOR_CONTENT_AGE_GROUP_VALUE,
  ).map((option) => option.value);

export const newAUStandaloneLessonAgeGroupOptions = [
  { label: "Kindy/Reception", value: "Kindy/Reception" },
  { label: "Year 1", value: "Year 1" },
  { label: "Year 2", value: "Year 2" },
  { label: "Year 3", value: "Year 3" },
  { label: "Year 4", value: "Year 4" },
  { label: "Year 5", value: "Year 5" },
  { label: "Year 6", value: "Year 6" },
  { label: "Year 7", value: "Year 7" },
  { label: "Year 8", value: "Year 8" },
  { label: "Year 9", value: "Year 9" },
  { label: "Year 10", value: "Year 10" },
  { label: "Year 11", value: "Year 11" },
  { label: "Year 12", value: "Year 12" },
  {
    label: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
    value: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
  },
];

export const NAStandaloneLessonAgeGroupOptions = [
  { label: "Pre-K", value: "Pre-K" },
  { label: "Kindergarten", value: "Kindergarten" },
  { label: "Grade 1", value: "Grade 1" },
  { label: "Grade 2", value: "Grade 2" },
  { label: "Grade 3", value: "Grade 3" },
  { label: "Grade 4", value: "Grade 4" },
  { label: "Grade 5", value: "Grade 5" },
  { label: "Grade 6", value: "Grade 6" },
  { label: "Grade 7", value: "Grade 7" },
  { label: "Grade 8", value: "Grade 8" },
  { label: "Grade 9", value: "Grade 9" },
  { label: "Grade 10", value: "Grade 10" },
  { label: "Grade 11", value: "Grade 11" },
  { label: "Grade 12", value: "Grade 12" },
  {
    label: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
    value: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
  },
];

export const superAdminStandaloneLessonsAgeOptions = [
  { label: "Pre-K & K", value: "Pre-K & K" },
  { label: "Grade 1 & 2", value: "Grade 1 & 2" },
  { label: "Grade 3 & 4", value: "Grade 3 & 4" },
  { label: "Grade 5 & 6", value: "Grade 5 & 6" },
  { label: "Grade 7 & 8", value: "Grade 7 & 8" },
  { label: "Grade 9 - 12", value: "Grade 9 - 12" },
  { label: "Grade K-3", value: "Grade K-3" },
  { label: "Grade 4-6", value: "Grade 4-6" },
  { label: "Grade 7-9", value: "Grade 7-9" },
  { label: "Grade 10-12", value: "Grade 10-12" },
  { label: "Grade K-12", value: "Grade K-12" },
  // New Options
  { label: "Pre-K", value: "Pre-K" },
  { label: "Kindergarten", value: "Kindergarten" },
  { label: "Grade 1", value: "Grade 1" },
  { label: "Grade 2", value: "Grade 2" },
  { label: "Grade 3", value: "Grade 3" },
  { label: "Grade 4", value: "Grade 4" },
  { label: "Grade 5", value: "Grade 5" },
  { label: "Grade 6", value: "Grade 6" },
  { label: "Grade 7", value: "Grade 7" },
  { label: "Grade 8", value: "Grade 8" },
  { label: "Grade 9", value: "Grade 9" },
  { label: "Grade 10", value: "Grade 10" },
  { label: "Grade 11", value: "Grade 11" },
  { label: "Grade 12", value: "Grade 12" },
  // New Options
  { label: "Kindy/Reception", value: "Kindy/Reception" },
  { label: "Year 1", value: "Year 1" },
  { label: "Year 2", value: "Year 2" },
  { label: "Year 3", value: "Year 3" },
  { label: "Year 4", value: "Year 4" },
  { label: "Year 5", value: "Year 5" },
  { label: "Year 6", value: "Year 6" },
  { label: "Year 7", value: "Year 7" },
  { label: "Year 8", value: "Year 8" },
  { label: "Year 9", value: "Year 9" },
  { label: "Year 10", value: "Year 10" },
  { label: "Year 11", value: "Year 11" },
  { label: "Year 12", value: "Year 12" },
  {
    label: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
    value: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
  },
];

export const superAdminStandaloneLessonsFilterOptions = [
  { label: "Pre-K", value: "Pre-K" },
  { label: "Kindergarten", value: "Kindergarten" },
  { label: "Grade 1", value: "Grade 1" },
  { label: "Grade 2", value: "Grade 2" },
  { label: "Grade 3", value: "Grade 3" },
  { label: "Grade 4", value: "Grade 4" },
  { label: "Grade 5", value: "Grade 5" },
  { label: "Grade 6", value: "Grade 6" },
  { label: "Grade 7", value: "Grade 7" },
  { label: "Grade 8", value: "Grade 8" },
  { label: "Grade 9", value: "Grade 9" },
  { label: "Grade 10", value: "Grade 10" },
  { label: "Grade 11", value: "Grade 11" },
  { label: "Grade 12", value: "Grade 12" },
  { label: "Icebreakers", value: "BrainBreaks" }, //Keep Icebreakers on AUS
  { label: "Getting Started", value: "Getting Started" },
  { label: "Caregiver", value: "Caregiver" },
  { label: "Kindy/Reception", value: "Kindy/Reception" },
  { label: "Year 1", value: "Year 1" },
  { label: "Year 2", value: "Year 2" },
  { label: "Year 3", value: "Year 3" },
  { label: "Year 4", value: "Year 4" },
  { label: "Year 5", value: "Year 5" },
  { label: "Year 6", value: "Year 6" },
  { label: "Year 7", value: "Year 7" },
  { label: "Year 8", value: "Year 8" },
  { label: "Year 9", value: "Year 9" },
  { label: "Year 10", value: "Year 10" },
  { label: "Year 11", value: "Year 11" },
  { label: "Year 12", value: "Year 12" },
  {
    label: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
    value: EDUCATOR_CONTENT_AGE_GROUP_VALUE,
  },
];

export const standaloneLessonsSelCompetencies = [
  { label: "Relationship Skills", value: "Relationship Skills" },
  {
    label: "Responsible Decision-Making",
    value: "Responsible Decision-Making",
  },
  { label: "Self-Awareness", value: "Self-Awareness" },
  { label: "Self-Management", value: "Self-Management" },
  { label: "Social Awareness", value: "Social Awareness" },
];

export const usProgramGradeLevels = [
  { label: "Grade 3", value: "Grade 3 Program" },
  { label: "Grade 4", value: "Grade 4 Program" },
  { label: "Grade 5", value: "Grade 5 Program" },
  { label: "Grade 6", value: "Grade 6 Program" },
  { label: "Grade 7", value: "Grade 7 Program" },
  { label: "Grade 8", value: "Grade 8 Program" },
  { label: "Grade 9", value: "Grade 9 Program" },
  { label: "Grade 10", value: "Grade 10 Program" },
  { label: "Grade 11", value: "Grade 11 Program" },
  { label: "Grade 12", value: "Grade 12 Program" },
];

export const auProgramGradeLevels = [
  { label: "Year 4", value: "Year 4" },
  { label: "Year 5", value: "Year 5" },
  { label: "Year 6", value: "Year 6" },
  { label: "Year 7", value: "Year 7" },
  { label: "Year 8", value: "Year 8" },
  { label: "Year 9", value: "Year 9" },
  { label: "Year 10", value: "Year 10" },
  { label: "Year 11", value: "Year 11" },
  { label: "Year 12", value: "Year 12" },
];

export const naAllProgramGradeLevels = [
  { label: "All Grades", value: "All Grades" },
  { label: "Grade 1", value: "Grade 1 Program" },
  { label: "Grade 2", value: "Grade 2 Program" },
  { label: "Grade 3", value: "Grade 3 Program" },
  { label: "Grade 4", value: "Grade 4 Program" },
  { label: "Grade 5", value: "Grade 5 Program" },
  { label: "Grade 6", value: "Grade 6 Program" },
  { label: "Grade 7", value: "Grade 7 Program" },
  { label: "Grade 8", value: "Grade 8 Program" },
  { label: "Grade 9", value: "Grade 9 Program" },
  { label: "Grade 10", value: "Grade 10 Program" },
  { label: "Grade 11", value: "Grade 11 Program" },
  { label: "Grade 12", value: "Grade 12 Program" },
];

export const IconInfo = "https://cdn.lordicon.com/dnmvmpfk.json";
export const ValidInputRegTest = /^[;:"'`''""…().+=,/?&@!A-Za-z0-9-_ ]*$/;

export const GettingStartedMode = ["Student Introduction", "Icebreakers"];
export const CareGiverMode = ["Caregiver Resources"];

export const gettingStartedGradeLevels = [
  "Grade K-3",
  "Grade 4-6",
  "Grade 7-9",
  "Grade 10-12",
];
export const newGettingStartedGradeLevels = [
  "Pre-K",
  "Kindergarten",
  "Grade 1",
  "Grade 2",
  "Grade 3",
  "Grade 4",
  "Grade 5",
  "Grade 6",
  "Grade 7",
  "Grade 8",
  "Grade 9",
  "Grade 10",
  "Grade 11",
  "Grade 12",
];
export const auGettingStartedGradeLevels = [
  "Kindy/Reception",
  "Year 1",
  "Year 2",
  "Year 3",
  "Year 4",
  "Year 5",
  "Year 6",
  "Year 7",
  "Year 8",
  "Year 9",
  "Year 10",
  "Year 11",
  "Year 12",
];
export const auBrainBreaksGradeLevels = [
  "Kindy/Reception - Year 2",
  "Year 3-4",
  "Year 5-6",
  "Year 7-8",
  "Year 9-12",
];
export const standaloneLessonsAgeLevels = [
  "Pre-K & K",
  "Grade 1 & 2",
  "Grade 3 & 4",
  "Grade 5 & 6",
  "Grade 7 & 8",
  "Grade 9 - 12",
];

export const knownGettingStartedOrder = [
  "introduction: play to win for wellness",
  "introduction play to win for wellness",
  "what is open parachute",
  "setting class boundaries",
  "what is mental health",
  "what is mental health & wellbeing",
];

export const preProgramQuizUnitId = isStage
  ? "9Fa8DPyxJ214HfD6sPXWs"
  : "9Fa8DPyxJ214HfD6sPXWs";

export const IconIdle = "https://cdn.lordicon.com/idhkhbvk.json";
export const IconAdminTop = "https://cdn.lordicon.com/pbxqbqdh.json";
export const IconInviteStaff = "https://cdn.lordicon.com/wzzgancm.json";
export const IconViewUsage = "https://cdn.lordicon.com/gqdnbnwt.json";
export const IconUserManage = "https://cdn.lordicon.com/akbjoiow.json";
export const IconLessonProgress = "https://cdn.lordicon.com/xtkehzkm.json";
export const IconReportTop = "https://cdn.lordicon.com/syzdvjlt.json";
export const IconSentryTracking = "https://cdn.lordicon.com/avcownel.json";
export const IconPreProgramSurvey = "https://cdn.lordicon.com/ufezupnm.json";
export const IconExitTicket = "https://cdn.lordicon.com/tgriojic.json";
export const IconStudentWellbeing = "https://cdn.lordicon.com/lsqbzprc.json";
export const IconGettingStarted = "https://cdn.lordicon.com/kbdsgbei.json";
export const IconQuickstartArticles = "https://cdn.lordicon.com/nspjpkdg.json";
export const IconSchoolOnboarding = "https://cdn.lordicon.com/oiveszhb.json";
export const IconDistrictOnboarding = "https://cdn.lordicon.com/ttawyujb.json";
export const IconScopeSequence = "https://cdn.lordicon.com/dlzzlyaa.json";
export const IconCurriculumMapping = "https://cdn.lordicon.com/jyfjmuti.json";
export const IconLessonRoadmaps = "https://cdn.lordicon.com/kjeyqivm.json";
export const IconBrainBreak = "https://cdn.lordicon.com/wzrwaorf.json";
export const IconEducatorOnboarding = "https://cdn.lordicon.com/qhtwmoaf.json";
export const IconLessonLibrary = "https://cdn.lordicon.com/pmfpsjek.json";
export const IconPrograms = "https://cdn.lordicon.com/tboujdsn.json";
export const IconAssessmentReports = "https://cdn.lordicon.com/syzdvjlt.json";
export const IconSummaryReports = "https://cdn.lordicon.com/tgriojic.json";
export const IconProfessionalDevelopment =
  "https://cdn.lordicon.com/gxfwmcto.json";
export const IconParentsCaregivers = "https://cdn.lordicon.com/dcalqqtv.json";
export const IconCaregiverIntroduction =
  "https://cdn.lordicon.com/gfxnyohe.json";
export const IconCaregiverResources = "https://cdn.lordicon.com/oiveszhb.json";
export const IconLiveChat = "https://cdn.lordicon.com/sfkskmhu.json";
export const IconViewActiveLessons = "https://cdn.lordicon.com/xtkehzkm.json";
export const IconStudentIntroduction = "https://cdn.lordicon.com/tlmejisy.json";
export const IconPreProgramQuiz = "https://cdn.lordicon.com/dlzzlyaa.json";
export const IconClassRoomTop = "https://cdn.lordicon.com/qtbtspmd.json";
export const IconMyCollection = "https://cdn.lordicon.com/tboujdsn.json";
export const IconStandalone = "https://cdn.lordicon.com/pmfpsjek.json";
export const IconProgram = "https://cdn.lordicon.com/vepuekor.json";
export const IconAdultResource = "https://cdn.lordicon.com/dcalqqtv.json";
export const IconEducator = "https://cdn.lordicon.com/omsynzud.json";
export const IconCaregiver = "https://cdn.lordicon.com/aswgwjjg.json";
export const IconDownArrow = "https://cdn.lordicon.com/ejwormhf.json";
export const IconUpArrow = "https://cdn.lordicon.com/ygydemai.json";
export const IconHandbook = "https://cdn.lordicon.com/ttawyujb.json";
export const IconGroupOnboarding = "https://cdn.lordicon.com/yuhdirfv.json";
export const IconKickOffCall = "https://cdn.lordicon.com/rfgxevig.json";
export const IconCommunity = "https://cdn.lordicon.com/shxbruzg.json";
export const IconHelp = "https://cdn.lordicon.com/sfkskmhu.json";
export const IconChat = "https://cdn.lordicon.com/zpxybbhl.json";
export const IconSupport = "https://cdn.lordicon.com/pciennjk.json";
export const IconShare = "https://cdn.lordicon.com/hlywgxmy.json";
export const IconCopy = "https://cdn.lordicon.com/zyeheivi.json";
export const IconLink = "https://cdn.lordicon.com/gsjfryhc.json";
export const IconEdit = "https://cdn.lordicon.com/exymduqj.json";
export const IconPassword = "https://cdn.lordicon.com/hdwwlnuo.json";
export const IconDeleteUser = "https://cdn.lordicon.com/qhpteyqa.json";
export const IconDeleteItem = "https://cdn.lordicon.com/jzinekkv.json";
export const IconReset = "https://cdn.lordicon.com/ijxxgzog.json";
export const IconMyAccount = "https://cdn.lordicon.com/unvvkseg.json";
export const IconIcebreakers = "https://cdn.lordicon.com/xpyyoyss.json";
export const IconResourceHub = "https://cdn.lordicon.com/glotcrgj.json";
export const IconDistAdmin = "https://cdn.lordicon.com/dflgefov.json";
export const IconUser = "https://cdn.lordicon.com/tdvuekwf.json";
export const IconSkills = [
  "https://cdn.lordicon.com/eesuaqpv.json",
  "https://cdn.lordicon.com/nvqxuepq.json",
  "https://cdn.lordicon.com/raitenkk.json",
  "https://cdn.lordicon.com/ntcrpjuj.json",
  "https://cdn.lordicon.com/xdkrtxaj.json",
  "https://cdn.lordicon.com/lyagdfpv.json",
  "https://cdn.lordicon.com/bklkawvx.json",
  "https://cdn.lordicon.com/estydxib.json",
  "https://cdn.lordicon.com/eesuaqpv.json",
  "https://cdn.lordicon.com/eesuaqpv.json",
  "https://cdn.lordicon.com/eesuaqpv.json",
  "https://cdn.lordicon.com/eesuaqpv.json",
  "https://cdn.lordicon.com/eesuaqpv.json",
  "https://cdn.lordicon.com/eesuaqpv.json",
  "https://cdn.lordicon.com/eesuaqpv.json",
  "https://cdn.lordicon.com/eesuaqpv.json",
  "https://cdn.lordicon.com/eesuaqpv.json",
  "https://cdn.lordicon.com/eesuaqpv.json",
];
export const IconSkill = "https://cdn.lordicon.com/cnfrxixw.json";
export const IconExercises = [
  "https://cdn.lordicon.com/hyvcwjxp.json",
  "https://cdn.lordicon.com/nvxzbopf.json",
  "https://cdn.lordicon.com/szsugnkj.json",
  "https://cdn.lordicon.com/wdwmyold.json",
  "https://cdn.lordicon.com/dgcjorgv.json",
  "https://cdn.lordicon.com/nwopwytz.json",
  "https://cdn.lordicon.com/lvytpuju.json",
  "https://cdn.lordicon.com/wzrwaorf.json",
];
export const IconComforts = [
  "https://cdn.lordicon.com/duvtntvw.json",
  "https://cdn.lordicon.com/zvbobvbw.json",
];
export const IconMoods = [
  "https://cdn.lordicon.com/ghqwgqjo.json",
  "https://cdn.lordicon.com/mjyxajfq.json",
  "https://cdn.lordicon.com/gbmbhcby.json",
  "https://cdn.lordicon.com/xxykmhhg.json",
  "https://cdn.lordicon.com/yfgatqxp.json",
];
export const IconStructures = [
  "https://cdn.lordicon.com/jxzomkqn.json",
  "https://cdn.lordicon.com/xucwtynk.json",
];
export const IconLesson = "https://cdn.lordicon.com/lenjvibx.json";
export const IconLessons = "https://cdn.lordicon.com/qtbtspmd.json";
export const IconGrade = "https://cdn.lordicon.com/rddqfodm.json";
export const IconInProgress = "https://cdn.lordicon.com/rqptwppx.json";
export const IconCourses = "https://cdn.lordicon.com/zxdhnzre.json";
export const IconClock = "https://cdn.lordicon.com/qvyppzqz.json";
export const IconBrain = "https://cdn.lordicon.com/mrikdaqa.json";
export const IconInventory = "https://cdn.lordicon.com/eeouelif.json";
export const IconRateLesson = "https://cdn.lordicon.com/rqdzxkkr.json";
export const IconResilent = "https://cdn.lordicon.com/eeouelif.json";
export const IconTier = "https://cdn.lordicon.com/qfrknxtz.json";
export const IconMood = "https://cdn.lordicon.com/mjyxajfq.json";
export const IconExtension = "https://cdn.lordicon.com/laksvpbf.json";
export const IconDirection = "https://cdn.lordicon.com/rhsygnto.json";
export const IconTargetArea = "https://cdn.lordicon.com/nchegqgo.json";
export const IconWellbeingFoundations =
  "https://cdn.lordicon.com/wzrwaorf.json";
export const IconTransitions = "https://cdn.lordicon.com/wzwygmng.json";
export const IconWellbeingFoundation = "https://cdn.lordicon.com/nmrhyntp.json";
export const IconSkillBuilder = "https://cdn.lordicon.com/mugstzjx.json";
export const IconRewards = "https://cdn.lordicon.com/bggiktkp.json";
export const IconTranslation = "https://cdn.lordicon.com/aucxxwfa.json";
export const IconTeacher = "https://cdn.lordicon.com/iamghtmu.json";
export const IconStudent = "https://cdn.lordicon.com/lujkiqza.json";
export const IconProjRequired = "https://cdn.lordicon.com/ripbvsga.json";
export const IconPhases = "https://cdn.lordicon.com/jxhgzthg.json";
export const IconSchoolLeader = "https://cdn.lordicon.com/oiveszhb.json";
export const IconProfessional = "https://cdn.lordicon.com/gxfwmcto.json";

export const createURL = (id: string) => {
  return `${window.location.origin}/ff/${id}`;
};

export const createStudentLink = (id: string, sllLesson?: boolean) => {
  return sllLesson
    ? `${window.location.origin}/student/${id}/?sll=${sllLesson}`
    : `${window.location.origin}/student/${id}`;
};

export const createPrettyURL = (
  unitName: string,
  lessonName?: string | null,
) => {
  let shareUrl = `${window.location.origin}/${unitName}`;
  if (lessonName) {
    shareUrl = shareUrl + `/${lessonName}`;
  }
  return shareUrl;
};

export const categoryStructureOptions = [
  { label: "Structured", value: "Structured" },
  { label: "Loosely Structured", value: "Loosely Structured" },
];

export const categoryMoodOptions1 = [
  { label: "Empowered", value: "Empowered" },
  { label: "Energetic", value: "Energetic" },
  { label: "Relaxed & Mindful", value: "Relaxed & Mindful" },
  { label: "Self-Reflective", value: "Self-Reflective" },
];

export const categoryMoodOptions2 = [
  { label: "Deep & Reflective", value: "Deep & Reflective" },
  { label: "Reflective", value: "Reflective" },
  { label: "Relaxed & Mindful", value: "Relaxed & Mindful" },
  { label: "Energetic", value: "Energetic" },
  { label: "Empowered", value: "Empowered" },
];

export const categoryTiersOptions = [
  { label: "Tier 1", value: "Tier 1" },
  { label: "Tier 2/3", value: "Tier 2/3", oldValues: ["Tier 2"] },
];

export const categoryDirectionOptions = [
  { label: "Skills", value: "Skills" },
  { label: "Support", value: "Support" },
];

export const categoryTargetAreaOptions = [
  { label: "Well-being", value: "Well-being" },
  { label: "Relationships", value: "Relationships" },
];

export const categoryStyleOptions = [
  // TO DO: currently, we have bad datas for the style options in the DB. We have to udpate the style manually at the edit-lesson
  // After DB update, we should remove the oldValues.
  {
    label: "Brain Break",
    value: "Brain Break",
    oldValues: ["Icebreakers", "BrainBreaks"],
  },
  {
    label: "Skill-Builder",
    value: "Skill-Builder",
    oldValues: ["Skill-Builders"],
  },
];

export const wellbeingFoundationOptions = {
  "student-introduction": "Student Introduction",
  brainbreaks: "Brain Breaks",
  skillbuilders: "Skill-Builders",
};

export const categoryComfortLevelOptions = [
  { label: "Light/Approachable", value: "Light/Approachable" },
  { label: "Requires Trust", value: "Requires Trust" },
];

export const categoryExerciseStyleOptions = [
  { label: "Case Study", value: "Case Study" },
  { label: "Physical", value: "Physical" },
  { label: "Interactive", value: "Interactive" },
  { label: "Activity", value: "Activity" },
  { label: "View & Respond", value: "View & Respond" },
  { label: "Independent", value: "Independent" },
  { label: "Project Based", value: "Project Based" },
  { label: "Discussion", value: "Discussion" },
];

export const categorySkillsOptions = [
  {
    label: "Developing Healthy Relationships",
    value: "Developing Healthy Relationships",
  },
  {
    label: "Stress Management Techniques",
    value: "Stress Management Techniques",
  },
  { label: "Strengthening Self-Esteem", value: "Strengthening Self-Esteem" },
  {
    label: "Accessing Mental Health Support",
    value: "Accessing Mental Health Support",
  },
  {
    label: "Practising Diversity Awareness",
    value: "Practising Diversity Awareness",
  },
  {
    label: "Career & Life Transition Preparation",
    value: "Career & Life Transition Preparation",
  },
  {
    label: "Social & Emotional Learning",
    value: "Social & Emotional Learning",
  },
  {
    label: "Fostering Positive Wellbeing Habits",
    value: "Fostering Positive Wellbeing Habits",
  },
  {
    label: "Building & Maintaining Friendships",
    value: "Building & Maintaining Friendships",
  },
  {
    label: "Recognising & Managing Emotions",
    value: "Recognising & Managing Emotions",
  },
  {
    label: "Seeking & Utilising Support",
    value: "Seeking & Utilising Support",
  },
  { label: "Building Resilience", value: "Building Resilience" },
  {
    label: "Developing a Growth Mindset",
    value: "Developing a Growth Mindset",
  },
  {
    label: "Coping with Worries & Anxiety",
    value: "Coping with Worries & Anxiety",
  },
  {
    label: "Managing Stress Effectively",
    value: "Managing Stress Effectively",
  },
  {
    label: "Demonstrating Acceptance & Respect",
    value: "Demonstrating Acceptance & Respect",
  },
  {
    label: "Practising Self-Support Strategies",
    value: "Practising Self-Support Strategies",
  },
  {
    label: "Practising Positive Thinking",
    value: "Practising Positive Thinking",
  },
];

export const categorySkillsOptions2 = [
  { label: "Relationship Skills", value: "Relationship Skills" },
  { label: "Self-Management", value: "Self-Management" },
  {
    label: "Practical Social & Emotional Skills",
    value: "Practical Social & Emotional Skills",
  },
  { label: "Positive Wellbeing", value: "Positive Wellbeing" },
  { label: "Career Preparation", value: "Career Preparation" },
  { label: "Self-Esteem", value: "Self-Esteem" },
];

export const categorySubjectMatterRatingOptions = [
  { label: "Accessible", value: "Accessible" },
  { label: "light and mature", value: "light and mature" },
  { label: "Mature", value: "Mature" },
];

export const timeExpiration = (expireTime: number) => {
  var currentTime = new Date().getTime();
  var agotime = Math.floor((expireTime - currentTime) / 86400000);
  var timeindex = " Days Left";
  if (isNaN(agotime)) {
    return "";
  }
  if (agotime === 0) {
    agotime = Math.floor((expireTime - currentTime) / 3600000);
    timeindex = " Hours Left";
  }
  if (agotime === 0) {
    agotime = Math.floor((expireTime - currentTime) / 60000);
    timeindex = " Mins Left";
  }
  if (agotime === 0) {
    agotime = Math.floor((expireTime - currentTime) / 1000);
    timeindex = " Sec Left";
  }
  return agotime + timeindex;
};

export const reportTypes = [
  { label: "Exit Ticket Summary", value: SURVEY_TYPE.EXIT_TICKET.toString() },
  {
    label: "Pre-Program Quiz",
    value: SURVEY_TYPE.NA_PRE_PROGRAM_QUIZ.toString(),
  },
  {
    label: "Post-Unit Assessment",
    value: SURVEY_TYPE.AU_POST_PROGRAM_QUIZ.toString(),
  },
];

export const UserActiveEvents: EventsType[] = [
  "keydown",
  "wheel",
  "DOMMouseScroll",
  "mousewheel",
  "mousedown",
  "touchstart",
  "touchmove",
  "MSPointerDown",
  "MSPointerMove",
  "visibilitychange",
];

export const themeOptions = {
  "Pre-K": [
    { label: "Feelings", value: "Feelings" },
    { label: "Friendship", value: "Friendship" },
    { label: "Making Choices", value: "Making Choices" },
    { label: "Helping Myself", value: "Helping Myself" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  Kindergarten: [
    { label: "Feelings", value: "Feelings" },
    { label: "Friendship", value: "Friendship" },
    { label: "Making Choices", value: "Making Choices" },
    { label: "Helping Myself", value: "Helping Myself" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 1": [
    { label: "Positive Thinking", value: "Positive Thinking" },
    { label: "Friendship", value: "Friendship" },
    { label: "Making Choices", value: "Making Choices" },
    { label: "Expressing Myself", value: "Expressing Myself" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 2": [
    { label: "Positive Thinking", value: "Positive Thinking" },
    { label: "Friendship", value: "Friendship" },
    { label: "Making Choices", value: "Making Choices" },
    { label: "Understanding Myself", value: "Understanding Myself" },
    { label: "Worries", value: "Worries" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 3": [
    { label: "Positive Thinking", value: "Positive Thinking" },
    { label: "Friendship", value: "Friendship" },
    { label: "Respectful Choices", value: "Respectful Choices" },
    { label: "Supporting Myself", value: "Supporting Myself" },
    { label: "Worries", value: "Worries" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 4": [
    { label: "Problem Solving", value: "Problem Solving" },
    { label: "Friendship", value: "Friendship" },
    { label: "Setting Limits", value: "Setting Limits" },
    { label: "Supporting Myself", value: "Supporting Myself" },
    { label: "Worries", value: "Worries" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 5": [
    { label: "Self-Esteem", value: "Self-Esteem" },
    { label: "Friendship", value: "Friendship" },
    { label: "Responsibility", value: "Responsibility" },
    { label: "Supporting Myself", value: "Supporting Myself" },
    { label: "Worries", value: "Worries" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 6": [
    { label: "Self-Esteem", value: "Self-Esteem" },
    { label: "Friendship", value: "Friendship" },
    { label: "Leadership", value: "Leadership" },
    { label: "Support", value: "Support" },
    { label: "Stress", value: "Stress" },
    { label: "Managing Change", value: "Managing Change" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 7": [
    { label: "Self-Worth", value: "Self-Worth" },
    { label: "Peer Dynamics", value: "Peer Dynamics" },
    { label: "Respect", value: "Respect" },
    { label: "Support", value: "Support" },
    { label: "Stress", value: "Stress" },
    { label: "Managing Change", value: "Managing Change" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 8": [
    { label: "Self-Worth", value: "Self-Worth" },
    { label: "Peer Influence", value: "Peer Influence" },
    { label: "Personal Accountability", value: "Personal Accountability" },
    { label: "Building Community", value: "Building Community" },
    { label: "Stress", value: "Stress" },
    { label: "Transitions", value: "Transitions" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 9": [
    { label: "Self-Worth", value: "Self-Worth" },
    { label: "Belonging", value: "Belonging" },
    { label: "Boundaries", value: "Boundaries" },
    { label: "Building Community", value: "Building Community" },
    { label: "Pressure", value: "Pressure" },
    { label: "Identity", value: "Identity" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 10": [
    { label: "Personal Struggles", value: "Personal Struggles" },
    { label: "Relationships", value: "Relationships" },
    { label: "Empowerment", value: "Empowerment" },
    { label: "Peer Support", value: "Peer Support" },
    { label: "Anxiety", value: "Anxiety" },
    { label: "The Future", value: "The Future" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 11": [
    { label: "Personal Struggles", value: "Personal Struggles" },
    { label: "Relationships", value: "Relationships" },
    { label: "Norms & Expectations", value: "Norms & Expectations" },
    { label: "Personal Antonomy", value: "Personal Antonomy" },
    { label: "Anxiety", value: "Anxiety" },
    { label: "The Future", value: "The Future" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
  "Grade 12": [
    { label: "Personal Struggles", value: "Personal Struggles" },
    { label: "Relationships", value: "Relationships" },
    { label: "Norms & Expectations", value: "Norms & Expectations" },
    { label: "Personal Antonomy", value: "Personal Antonomy" },
    { label: "Anxiety", value: "Anxiety" },
    { label: "The Future", value: "The Future" },
    { label: "Wellbeing Foundations", value: "Wellbeing Foundations" },
  ],
};

export const timeAgo = (lastTime: number | string | null | undefined) => {
  const timestamp = Number(lastTime);
  if (!timestamp || Number.isNaN(timestamp) || timestamp <= 0) {
    return "a long time ago";
  }

  var currentTime = new Date().getTime();
  var agotime = Math.floor((currentTime - timestamp) / 31556926000);
  var timeindex = " years ago";
  if (isNaN(agotime)) {
    return "";
  }
  if (agotime === 0) {
    agotime = Math.floor((currentTime - timestamp) / 2629743000);
    timeindex = " month ago";
  }
  if (agotime === 0) {
    agotime = Math.floor((currentTime - timestamp) / 604800000);
    timeindex = " week ago";
  }
  if (agotime === 0) {
    agotime = Math.floor((currentTime - timestamp) / 86400000);
    timeindex = " days ago";
  }
  if (agotime === 0) {
    agotime = Math.floor((currentTime - timestamp) / 3600000);
    timeindex = " hour ago";
  }
  if (agotime === 0) {
    agotime = Math.floor((currentTime - timestamp) / 60000);
    timeindex = " min ago";
  }
  if (agotime === 0) {
    agotime = Math.floor((currentTime - timestamp) / 1000);
    timeindex = " sec ago";
  }
  return agotime + timeindex;
};

export const naAllGradeLevels = [
  { label: "Pre-K", value: "Pre-K" },
  { label: "Kindergarten", value: "Kindergarten" },
  { label: "Grade 1", value: "Grade 1" },
  { label: "Grade 2", value: "Grade 2" },
  { label: "Grade 3", value: "Grade 3" },
  { label: "Grade 4", value: "Grade 4" },
  { label: "Grade 5", value: "Grade 5" },
  { label: "Grade 6", value: "Grade 6" },
  { label: "Grade 7", value: "Grade 7" },
  { label: "Grade 8", value: "Grade 8" },
  { label: "Grade 9", value: "Grade 9" },
  { label: "Grade 10", value: "Grade 10" },
  { label: "Grade 11", value: "Grade 11" },
  { label: "Grade 12", value: "Grade 12" },
];

export const auAllYearLevels = [
  { label: "Kindy/Reception", value: "Kindy/Reception" },
  { label: "Year 1", value: "Year 1" },
  { label: "Year 2", value: "Year 2" },
  { label: "Year 3", value: "Year 3" },
  { label: "Year 4", value: "Year 4" },
  { label: "Year 5", value: "Year 5" },
  { label: "Year 6", value: "Year 6" },
  { label: "Year 7", value: "Year 7" },
  { label: "Year 8", value: "Year 8" },
  { label: "Year 9", value: "Year 9" },
  { label: "Year 10", value: "Year 10" },
  { label: "Year 11", value: "Year 11" },
  { label: "Year 12", value: "Year 12" },
];

export const ALL_GRADES_LABEL = "All Grades";
export const ALL_YEARS_LABEL = "All Years";

export const AU_ALL_YEARS_VALUES = auAllYearLevels.map(
  (option) => option.value,
);

export const ausLessonOverviewLink =
  "https://help.openparachuteschools.com/en/articles/10468974";

export const naLessonOverviewLink =
  "https://help.openparachuteschools.com/en/collections/10539269";

export const scopeSequences = {
  "Pre-K":
    "https://help.openparachuteschools.com/en/articles/9269796-pre-k-scope-sequence",
  Kindergarten:
    "https://help.openparachuteschools.com/en/articles/9488950-kindergarten-scope-sequence",
  "Grade 1":
    "https://help.openparachuteschools.com/en/articles/9489015-grade-1-scope-sequence",
  "Grade 2":
    "https://help.openparachuteschools.com/en/articles/9489017-grade-2-scope-sequence",
  "Grade 3":
    "https://help.openparachuteschools.com/en/articles/9489019-grade-3-scope-sequence",
  "Grade 4":
    "https://help.openparachuteschools.com/en/articles/9489021-grade-4-scope-sequence",
  "Grade 5":
    "https://help.openparachuteschools.com/en/articles/9489022-grade-5-scope-sequence",
  "Grade 6":
    "https://help.openparachuteschools.com/en/articles/9489024-grade-6-scope-sequence",
  "Grade 7":
    "https://help.openparachuteschools.com/en/articles/9489026-grade-7-scope-sequence",
  "Grade 8":
    "https://help.openparachuteschools.com/en/articles/9489027-grade-8-scope-sequence",
  "Grade 9":
    "https://help.openparachuteschools.com/en/articles/9489029-grade-9-scope-sequence",
  "Grade 10":
    "https://help.openparachuteschools.com/en/articles/9489030-grade-10-scope-sequence",
  "Grade 11":
    "https://help.openparachuteschools.com/en/articles/9489032-grade-11-scope-sequence",
  "Grade 12":
    "https://help.openparachuteschools.com/en/articles/9489033-grade-12-scope-sequence",
  "Year 7":
    "https://help.openparachuteschools.com/en/articles/10468974-lesson-overviews-year-7",
  "Year 8":
    "https://help.openparachuteschools.com/en/articles/10469005-lesson-overviews-year-8",
  "Year 9":
    "https://help.openparachuteschools.com/en/articles/10469009-lesson-overviews-year-9",
  "Year 10":
    "https://help.openparachuteschools.com/en/articles/10469010-lesson-overviews-year-10",
  "Year 11":
    "https://help.openparachuteschools.com/en/articles/10469012-lesson-overviews-year-11",
  "Year 12":
    "https://help.openparachuteschools.com/en/articles/10469013-lesson-overviews-year-12",
};

export const transitionsScopeSequences = {
  "Grade 5 & 6":
    "https://help.openparachuteschools.com/en/articles/9939422-transitions-scope-sequence-grade-5-6",
  "Grade 7":
    "https://help.openparachuteschools.com/en/articles/9939461-transitions-scope-sequence-grade-7",
  "Grade 8 & 9":
    "https://help.openparachuteschools.com/en/articles/9939468-transitions-scope-sequence-grade-8-9",
  "Year 5 & 6":
    "https://help.openparachuteschools.com/en/articles/9981119-transitions-scope-sequence-year-5-6",
  "Year 7":
    "https://help.openparachuteschools.com/en/articles/9981148-transitions-scope-sequence-year-7",
  "Year 8":
    "https://help.openparachuteschools.com/en/articles/9981157-transitions-scope-sequence-year-8",
};

export const counselorCollectionScopeSequences = {
  "Pre-K to Grade 2":
    "https://help.openparachuteschools.com/en/articles/10023419",
  "Grade 3 to 5": "https://help.openparachuteschools.com/en/articles/10023419",
  "Grade 6 to 8": "https://help.openparachuteschools.com/en/articles/10023419",
  "Grade 9 to 10": "https://help.openparachuteschools.com/en/articles/10023419",
  "Grade 11 to 12":
    "https://help.openparachuteschools.com/en/articles/10023419",
};

export const ausStudentVoiceSeriesScopeSequences = {
  "Kindy/Reception":
    "https://help.openparachuteschools.com/en/articles/9492790-scope-sequence-kindy",
  "Year 1":
    "https://help.openparachuteschools.com/en/articles/10468949-scope-sequence-year-1",
  "Year 2":
    "https://help.openparachuteschools.com/en/articles/10468951-scope-sequence-year-2",
  "Year 3":
    "https://help.openparachuteschools.com/en/articles/10468952-scope-sequence-year-3",
  "Year 4":
    "https://help.openparachuteschools.com/en/articles/10468953-scope-sequence-year-4",
  "Year 5":
    "https://help.openparachuteschools.com/en/articles/10468954-scope-sequence-year-5",
  "Year 6":
    "https://help.openparachuteschools.com/en/articles/10468956-scope-sequence-year-6",
  "Year 7":
    "https://help.openparachuteschools.com/en/articles/10468957-scope-sequence-year-7",
  "Year 8":
    "https://help.openparachuteschools.com/en/articles/10468958-scope-sequence-year-8",
  "Year 9":
    "https://help.openparachuteschools.com/en/articles/10468961-scope-sequence-year-9",
  "Year 10":
    "https://help.openparachuteschools.com/en/articles/10468962-scope-sequence-year-10",
  "Year 11":
    "https://help.openparachuteschools.com/en/articles/10468963-scope-sequence-year-11",
  "Year 12":
    "https://help.openparachuteschools.com/en/articles/10468966-scope-sequence-year-12",
};

export const colors = [
  "#FFB3B3",
  "#CADEFC",
  "#9EE6CF",
  "#F0D9FF",
  "#DFF4F3",
  "#FFCFDF",
  "#FFDBA4",
  "#FFD9C0",
  "#DEECFF",
  "#CDF0EA",
  "#FFE9AE",
  "#C1EFFF",
  "#D9D6FF",
  "#FFF3B3",
];
export const darkColors = [
  "#FF7E7E",
  "#94BFFF",
  "#4ECCA4",
  "#BB7AE4",
  "#69D7D1",
  "#FC75A2",
  "#FFB648",
  "#FFA467",
  "#A4A8FF",
  "#69D7C4",
  "#FAC947",
  "#51D2FF",
  "#8075FC",
  "#FFD600",
];

export const programOptions = [
  { label: "Student Voice Series", value: "studentvoiceseries" },
  { label: "Transitions™", value: "transitions" },
  { label: "Counselor Collection", value: "counsellor" },
];

export const ausPrimaySchoolProgramsMenuOptions = [
  { label: "Student Voice Series", value: "studentvoiceseries" },
  { label: "Transitions™", value: "transitions" },
];

export const programMenuOptions = [
  { label: "Student Voice Series", value: "studentvoiceseries" },
  { label: "Transitions™", value: "transitions" },
  { label: "Lesson Library", value: "lessonlibrary" },
  { label: "Counselor Collection", value: "counsellor" },
];

export const lessonTypeLabels = {
  "0": "Student Voice",
  "1": "Positive Pathways",
  "2": "Brain Break",
  "3": "Skill-Builder",
  "4": "Educator Content",
  "5": "Resource",
  "6": "Student Introduction",
  "7": "Caregiver",
};

export const lessonTypeOptions = [
  { label: "Student Voice", value: "0" },
  { label: "Positive Pathways", value: "1" },
  { label: "Brain Break", value: "2" },
  { label: "Skill-Builder", value: "3" },
  { label: "Educator Content", value: "4" },
  { label: "Resource", value: "5" },
  { label: "Student Introduction", value: "6" },
  { label: "Caregiver", value: "7" },
];

export const lessonLibraryTypeOptions = lessonTypeOptions.filter(
  ({ value }) => !["4", "5", "6", "7"].includes(value),
);

export const lessonTypeOptionsWithNone = [
  { label: "None", value: "9" },
  { label: "Student Voice", value: "0" },
  { label: "Positive Pathways", value: "1" },
  { label: "Brain Break", value: "2" },
  { label: "Skill-Builder", value: "3" },
  { label: "Educator Content", value: "4" },
  { label: "Resource", value: "5" },
  { label: "Student Introduction", value: "6" },
  { label: "Caregiver", value: "7" },
];

export const categoryPhasesOptions = [
  { label: "Participatory", value: "Participatory" },
  {
    label: "Participatory/Transformative",
    value: "Participatory/Transformative",
  },
  { label: "School-Wide Opportunity", value: "School-Wide Opportunity" },
  { label: "Transformative", value: "Transformative" },
  { label: "Transformative/Universal", value: "Transformative/Universal" },
  { label: "Universal", value: "Universal" },
];

export enum ProgramID {
  BRAINBREAKS = "K9CFsoAAWN1lBEJMY6CBx",
  AUSBRAINBREAKS = "4MJjL7u62taY90FMzWK49",
  SKILLBUILDER = "UggKeQx3m832fD9jN_Q2A",
  AUSSKILLBUILDER = "FsYFH0NdaZ7oYhTrsa-L3",
  STUDENTINTRODUCTION = "bPt6UZcqYygS-pAzJiyyU",
  AUSSTUDENTINTRODUCTION = "f9RZM3C4wU-r8sbVaRBs-",
  LESSONLIBRARY = "TIpO_zrWDsBK-4OpFzCOk",
  AUSLESSONLIBRARY = "CvsCvxSsD-E0Vv9ea1q1i",
  MULTILESSONUNITS = "mLcFOFz5C8QdJSb2-w0lG",
  AUSTRANSITIONS = "Hhmi7tdAbn3JUnDBuC-mG",
  EDUCATORONBOARDING = "aLYHriE6Nx6geYDZ_gTij",
  EDUCATORONBOARDINGAU = "5aDstSYmlT4S72kqh5h1O",
  PROFESSIONALDEV = "sMQEvXWDSZhHJarKvjqQy",
  AUPROFESSIONALDEV = "i55d-ckNOIuvhCMWS9YZn",
}

export const ausProgramMenuOptions = [
  { label: "Programs", value: "Programs" },
  { label: "Student Voice Series", value: "Student Voice Series" },
];

export const schoolProgramOptions = [
  { label: "Lesson Library", value: "Lesson Library" },
  { label: "Transitions", value: "Transitions" },
  { label: "Brain Breaks", value: "Brain Breaks" },
  { label: "Educator Wellbeing", value: "Educator Wellbeing" },
  {
    label: "Creating Resilient Classrooms",
    value: "Creating Resilient Classrooms",
  },
];

export const caregiverLessonsOrder = [
  "building resilience",
  "teaching empathy & accountability",
  "healthy habits with social media",
  "teaching your child to say no",
  "building self-esteem",
  "when your child acts out",
  "coping with bullying",
  "supporting mental health at home",
  "changing addictive patterns",
  "supporting your child through trauma",
  "teaching about boundaries & consent",
  "coping with anxiety & depression",
  "helping your child transition from elementary to middle school",
];

// Additional icon exports for header components
export const IconDashboard = "https://cdn.lordicon.com/haevqykp.json";
export const IconGetting = "https://cdn.lordicon.com/vycbtszy.json";
export const IconLogout = "https://cdn.lordicon.com/moscwhoj.json";
export const IconOffice = "https://cdn.lordicon.com/kbtmbyzy.json";
export const IconUsers = "https://cdn.lordicon.com/akbjoiow.json";
export const IconHeLinks = "https://cdn.lordicon.com/fmnowuba.json";
export const IconHeUsers = "https://cdn.lordicon.com/akbjoiow.json";
export const IconGroups = "https://cdn.lordicon.com/dgiidarp.json";
export const IconUnits = "https://cdn.lordicon.com/liznhaat.json";
export const IconAccounts = "https://cdn.lordicon.com/zpqishmx.json";
export const IconNav = "https://cdn.lordicon.com/qwegujbf.json";
export const IconArrow = "https://cdn.lordicon.com/zpcieyfp.json";

export const cheatSheetLink =
  "https://help.openparachuteschools.com/en/collections/15504813-cheat-sheets";
